module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-thomas.2a924962.jpeg";